





























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import One from "./components/One.vue";
import Three from "./components/Three.vue";
@Component({
  components: {
    SideBar,
    One,
    Three
  }
})
export default class RecruitCampus extends Vue {
  isFixed = false;
  offsetTop = 500;
  activeIndex = 0;
  list = [
    {
      title: "加入我们",
      desc: "做数字化人才发展使能者"
    },
    {
      title: "四大城市，八场宣讲会",
      desc: "期待与优秀的你相遇"
    },
    {
      title: "招聘岗位一览",
      desc: "用最优秀的人培养更优秀的人"
    }
  ];
  mounted() {
    //
    window.addEventListener("scroll", this.handleScroll);
  }
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  menuShow(i) {
    this.activeIndex = i;
    // console.log(this.activeIndex);
    // 判断当前tab有没有吸顶
    if (this.isFixed) {
      window.scrollTo({
        top: 500,
        behavior: "smooth"
      });
    }
  }
  handleScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    const offsetTop = (document.getElementById("bar") as any).offsetTop;
    // console.log("scrollTop", scrollTop);
    // console.log("offsetTop", offsetTop);

    if (scrollTop > 500) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }
}
